// extracted by mini-css-extract-plugin
module.exports = {"container":"AppliedFilter_container__367IQ","link":"AppliedFilter_link__1PI4F"};